import miniToastr from "mini-toastr";

const defaultConfig = {
	timeout: 4000,
};
const toastr = miniToastr.init(defaultConfig);

export { toastr };
